module.exports = __webpack_public_path__ + "static/media/4.55feef4d.jpg";